import './mask-field-list-translated-string.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import _ from 'lodash';
import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons'

import { EntityField, EntityFieldStatus, createTranslatedString } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { MaskFieldText } from '../mask-field-text';
import { MaskFieldUpdateEvent, MaskFieldUpdateEventType } from '../mask-field';

@Component({
    components: {
        sMaskFieldText: MaskFieldText,
    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-list-translated-string.html')
})
export class MaskFieldListTranslatedString extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: string
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private trashIcon = faTrash
    private addIcon = faPlusCircle

    private values: any[] = []

    private mounted() {
        this.values = this.fieldValue ?? []
    }

    private updateChangeEvent(event: MaskFieldUpdateEvent, index: number) {
        let updatedEvent: MaskFieldUpdateEvent = {...event}
        
        updatedEvent.fieldPath = updatedEvent.fieldPath.replace(
            `${this.entityField.path}`,
            `${this.entityField.path}.${index}`
        )

        this.$emit("value-change", updatedEvent)
    }

    private onDeleteClick(index: number) {
        const path = `${this.entityField.path}[${index}]`

        this.$emit(
            'value-change',
            {
                abstractEntity: this.entityField.abstractEntity,
                fieldPath: path,
                value: null,
                type: MaskFieldUpdateEventType.DELETE,
            } as MaskFieldUpdateEvent
        )
    }

    private getEntityField(): EntityField {
        let result = _.cloneDeep(this.entityField)
        result.type.type = "TranslatedString"
        return result
    }

    private isReadonly(entityField: EntityField) {
        return entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }

    private getDataCy(index?: number): String {
        let res: string = this.entityField.path
        if(this.dataCy) {
            res = this.dataCy
        }
        if(index !== undefined && index !== null) {
            res = `${res}.${index}`
        }

        return res
    }

    @Watch('fieldValue')
    private onfFieldValueChanged() {
        this.values = this.fieldValue ?? []
    }

}